import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../Components/Layout';
import Integration from '../Integration/Integration';

function AgencyIntegration() {
  const authUser = useSelector((s) => s.auth?.user);
  const selectedUserId = authUser?._id || authUser?.userId || authUser?.id || undefined;

  return (
    // <Layout>
    
      <Integration selectedUserId={selectedUserId} />

    // </Layout>
  );
}

export default AgencyIntegration;


